module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('nav-bar'), _vm._v(" "), _c('div', {
    staticClass: "sidebar bg-darkgrey navbar-inverse side-box-shadow"
  }, [_c('ul', {
    staticClass: "nav flex-column"
  }, [_c('li', {
    staticClass: "nav-item",
    attrs: {
      "id": "current"
    }
  }, [_c('a', {
    staticClass: "nav-link navbar-text",
    attrs: {
      "href": "#/TransferPending"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('TransferPending.sidebar.pending')) + "\n            ")]), _vm._v(" "), (_vm.transfers.length > 0) ? _c('span', {
    staticClass: "pull-right badge badge-default"
  }, [_vm._v(_vm._s(_vm.transfers.length))]) : _vm._e()]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link navbar-text",
    attrs: {
      "href": "#/TransferCurrent"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('TransferPending.sidebar.completed')) + "\n            ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "view"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h3', {
    staticClass: "my-2"
  }, [_vm._v(_vm._s(_vm.$t('TransferPending.title')))])]), _vm._v(" "), _c('paginate', {
    attrs: {
      "name": "filterResults",
      "tag": "div",
      "list": _vm.filterResults,
      "per": 40
    }
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-hover font-grey mb-0 table-sm"
  }, [_c('thead', {
    staticClass: "bg-darkgrey"
  }, [_c('tr', [_c('th', {
    staticClass: "sortable nowrap",
    on: {
      "click": function($event) {
        _vm.sortBy('.key', false)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('TransferPending.order'))), (_vm.sort.current === '.key') ? _c('i', {
    staticClass: "ml-1 fa",
    class: {
      'fa-arrow-down': _vm.sort.desc, 'fa-arrow-up': !_vm.sort.desc
    },
    attrs: {
      "aria-hidden": "true"
    }
  }) : _vm._e()]), _vm._v(" "), _c('th', {
    staticClass: "sortable nowrap",
    on: {
      "click": function($event) {
        _vm.sortBy('vin', false)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('TransferPending.VIN'))), (_vm.sort.current === 'vin') ? _c('i', {
    staticClass: "ml-1 fa",
    class: {
      'fa-arrow-down': _vm.sort.desc, 'fa-arrow-up': !_vm.sort.desc
    },
    attrs: {
      "aria-hidden": "true"
    }
  }) : _vm._e()]), _vm._v(" "), _c('th', {
    staticClass: "sortable nowrap",
    on: {
      "click": function($event) {
        _vm.sortBy('creationDate', false)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('TransferPending.date'))), (_vm.sort.current === 'creationDate') ? _c('i', {
    staticClass: "ml-1 fa",
    class: {
      'fa-arrow-down': _vm.sort.desc, 'fa-arrow-up': !_vm.sort.desc
    },
    attrs: {
      "aria-hidden": "true"
    }
  }) : _vm._e()]), _vm._v(" "), _c('th', {
    staticClass: "sortable nowrap",
    on: {
      "click": function($event) {
        _vm.sortBy('transmitterName', false)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('TransferPending.pickup'))), (_vm.sort.current === 'transmitterName') ? _c('i', {
    staticClass: "ml-1 fa",
    class: {
      'fa-arrow-down': _vm.sort.desc, 'fa-arrow-up': !_vm.sort.desc
    },
    attrs: {
      "aria-hidden": "true"
    }
  }) : _vm._e()]), _vm._v(" "), _c('th', {
    staticClass: "sortable nowrap",
    on: {
      "click": function($event) {
        _vm.sortBy('receiverName', false)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('TransferPending.delivery'))), (_vm.sort.current === 'receiverName') ? _c('i', {
    staticClass: "ml-1 fa",
    class: {
      'fa-arrow-down': _vm.sort.desc, 'fa-arrow-up': !_vm.sort.desc
    },
    attrs: {
      "aria-hidden": "true"
    }
  }) : _vm._e()]), _vm._v(" "), _c('th', {
    staticClass: "sortable nowrap",
    on: {
      "click": function($event) {
        _vm.sortBy('nameTransfered', false)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('TransferPending.carrier'))), (_vm.sort.current === 'nameTransfered') ? _c('i', {
    staticClass: "ml-1 fa",
    class: {
      'fa-arrow-down': _vm.sort.desc, 'fa-arrow-up': !_vm.sort.desc
    },
    attrs: {
      "aria-hidden": "true"
    }
  }) : _vm._e()])])]), _vm._v(" "), _c('transition-group', {
    attrs: {
      "name": "fade",
      "tag": "tbody"
    }
  }, [_c('tr', {
    key: "filter"
  }, [_c('td', [_c('regular-input', {
    attrs: {
      "value": _vm.fields['.key'],
      "placeholder": _vm.$t('TransferPending.order')
    },
    on: {
      "input": function($event) {
        _vm.fields['.key'] = $event;
        _vm.filteredSearchMethod()
      }
    }
  })], 1), _vm._v(" "), _c('td', [_c('regular-input', {
    attrs: {
      "value": _vm.fields.vin,
      "placeholder": _vm.$t('TransferPending.VIN')
    },
    on: {
      "input": function($event) {
        _vm.fields.vin = $event;
        _vm.filteredSearchMethod()
      }
    }
  })], 1), _vm._v(" "), _c('td', [_c('regular-input', {
    attrs: {
      "value": _vm.fields.creationDate,
      "placeholder": _vm.$t('TransferPending.date')
    },
    on: {
      "input": function($event) {
        _vm.fields.creationDate = $event;
        _vm.filteredSearchMethod()
      }
    }
  })], 1), _vm._v(" "), _c('td', [_c('regular-input', {
    attrs: {
      "value": _vm.fields.transmitterName,
      "placeholder": _vm.$t('TransferPending.pickup')
    },
    on: {
      "input": function($event) {
        _vm.fields.transmitterName = $event;
        _vm.filteredSearchMethod()
      }
    }
  })], 1), _vm._v(" "), _c('td', [_c('regular-input', {
    attrs: {
      "value": _vm.fields.receiverName,
      "placeholder": _vm.$t('TransferPending.delivery')
    },
    on: {
      "input": function($event) {
        _vm.fields.receiverName = $event;
        _vm.filteredSearchMethod()
      }
    }
  })], 1), _vm._v(" "), _c('td', [_c('regular-input', {
    attrs: {
      "value": _vm.fields.nameTransfered,
      "placeholder": _vm.$t('TransferPending.carrier')
    },
    on: {
      "input": function($event) {
        _vm.fields.nameTransfered = $event;
        _vm.filteredSearchMethod()
      }
    }
  })], 1)]), _vm._v(" "), _vm._l((_vm.paginated('filterResults')), function(transfer) {
    return _c('tr', {
      key: transfer['.key']
    }, [_c('td', {
      staticClass: "nowrap"
    }, [_vm._v(_vm._s(transfer['.key']))]), _vm._v(" "), _c('td', {
      staticClass: "nowrap"
    }, [_vm._v(_vm._s(transfer.vin))]), _vm._v(" "), _c('td', {
      staticClass: "nowrap"
    }, [_vm._v(_vm._s(_vm.getDate(transfer.creationDate)))]), _vm._v(" "), _c('td', {
      staticClass: "nowrap"
    }, [_c('p', {
      staticClass: "table-fix-width"
    }, [_vm._v(_vm._s(transfer.transmitterName))])]), _vm._v(" "), _c('td', {
      staticClass: "nowrap"
    }, [_c('p', {
      staticClass: "table-fix-width"
    }, [_vm._v(_vm._s(transfer.receiverName))])]), _vm._v(" "), _c('td', {
      staticClass: "nowrap"
    }, [_vm._v(_vm._s(transfer.nameTransfered))])])
  })], 2)], 1)])]), _vm._v(" "), _c('paginate-links', {
    attrs: {
      "for": "filterResults",
      "hide-single-page": true,
      "limit": 5
    }
  })], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f48dba7e","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/view/TransferPending.vue
// module id = 853
// module chunks = 1